import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import {VOICE_CHAT_TYPE} from "utils";
import {useGetUser} from "hooks";
import {showPopUp, TwoBtnPopUp} from "components/PopUp";
// import MyInfo from "components/PopUp/MyInfo";
import ContextMenu from "../ContextMenu";
import micOnIcon from "images/voiceChat/ic_private_mic_on.svg";
import micOffIcon from "images/voiceChat/ic_private_mic_off.svg";
import profileDefaultImage from "images/common/avatar-default-profile-image.png";
import classNames from "classnames/bind";
import styles from "./index.module.scss";

const User = ({
  intl,
  user,
  isMine,
  micStatus,
  volumeData,
  privateChatStatus,
  getUserAttributes,
  sendCall,
  isWorldTab,
  currentChatMode,
  voiceChatType,
}) => {
  const cn = classNames.bind(styles);
  const myInfo = useSelector(state => state.userinfo);
  const userRef = useRef(null);
  const [userInfo, setUserInfo] = useState(user);
  const [isClick, setIsClick] = useState(false);
  const [xPos, setXPos] = useState(0);
  const [yPos, setYPos] = useState(0);

  let userCI;
  if (userInfo.ci) {
    userCI = userInfo.ci;
  } else {
    userCI = new Buffer.from(userInfo.uid, "base64").toString("utf8");
  }
  const {data: _userInfo} = useGetUser(userCI);

  useEffect(() => {
    if (isMine) return;
    if (!userInfo.name) {
      getUserInfoById(userInfo.uid);
    } else if (!userInfo.uid) {
      getUserInfoById(userInfo.id.toString());
    }
  }, []);

  const getUserInfoById = async id => {
    const newData = await getUserAttributes(id);
    setUserInfo({...userInfo, ...newData, uid: id});
  };

  const onClickRight = e => {
    e.preventDefault();
    const isMyId = new Buffer.from(myInfo.id).toString("base64");
    if (isMyId === userInfo.uid) return;
    if (e.type === "contextmenu" || e.type === "touchend") {
      setIsClick(true);
      setYPos(userRef.current.getBoundingClientRect().top);
      setXPos(e.pageX ? e.pageX : e.changedTouches[0].clientX);
    }
  };

  const onClickProfile = async () => {
    // const ci = new Buffer.from(userInfo.uid, "base64").toString("utf8");
    // showPopUp(<MyInfo otherId={ci} isMyInfo={false} />, {
    //   isOverlapPopup: true,
    //   defaultPadding: false,
    //   dismissButton: true,
    //   closeEscButton: true,
    // });
  };

  // NOTE : not working anymore
  const onClickBlock = () => {};

  const onClick = async () => {
    const userId = userInfo.uid;
    if (privateChatStatus === "onLine") {
      if (currentChatMode === VOICE_CHAT_TYPE[0]) {
        showPopUp(
          <TwoBtnPopUp
            title={intl.formatMessage({id: "ID_VOICE_CHAT_PRIVATE_CHAT_ENTER"}, {user: userInfo.name})}
            confirmAction={() => sendCall(userId)}
          />,
          {defaultPadding: false},
        );
      } else {
        sendCall(userId);
      }
    }
  };

  const defaultIcon = profileDefaultImage;
  const icon = _userInfo?.icon || defaultIcon;
  return (
    <div className={cn("voice_chat_user")}>
      <img
        className={cn(
          "thumbnail",
          voiceChatType === VOICE_CHAT_TYPE[0] && volumeData.includes(userInfo.uid ? userInfo.uid : userInfo.id) && "speak",
        )}
        src={icon}
        alt="thumbnail"
      />
      <p ref={userRef} onContextMenu={onClickRight} onTouchEnd={onClickRight}>
        {userInfo.name}
      </p>
      {isMine ? null : !isWorldTab && privateChatStatus !== "meeting" ? (
        <StateButton cn={cn} intl={intl} status={userInfo.status} onClick={onClick} />
      ) : (
        <DeviceState cn={cn} intl={intl} status={userInfo.status} micStatus={micStatus} />
      )}
      {isClick && (
        <ContextMenu xPos={xPos} yPos={yPos} setIsClick={setIsClick} onClickProfile={onClickProfile} onClickBlock={onClickBlock} />
      )}
    </div>
  );
};

const DeviceState = ({cn, micStatus}) => {
  return (
    <div className={cn("device_state")}>
      <img src={micStatus ? micOnIcon : micOffIcon} alt="mic control" />
    </div>
  );
};

const StateButton = ({cn, intl, status, onClick}) => {
  return (
    <button type="button" className={cn(status)} onClick={onClick}>
      {status === "calling" && intl.formatMessage({id: "ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST_ING"})}
      {status === "meeting" && intl.formatMessage({id: "ID_VOICE_CHAT_PRIVATE_CHAT_CALLING"})}
      {!["calling", "meeting"].includes(status) && intl.formatMessage({id: "ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST"})}
    </button>
  );
};

export default injectIntl(User);
